var exports = {
  "kL": "xe533113f--661ff9--container",
  "$h": "xe533113f--661ff9--closed",
  "Qs": "xe533113f--661ff9--content",
  "R_": "xe533113f--661ff9--heading",
  "DD": "xe533113f--661ff9--title",
  "c5": "xe533113f--661ff9--arrow-wrapper",
};

module.exports = exports;
